module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-event-fill-0c2c6cec.svg";